module.exports = __webpack_public_path__ + "media/src/ui/icons/png_new-11e24509e2202daab6e4ef203260e82e.svg";